import type { AvatarArt } from '@pixelworld/game-core/client';
import { useEffect, useState } from 'react';
import { clientGames } from '../../game-host/registry';

/** The first game that can draw the figures, loaded on demand; `null` until it has loaded. */
export function useAvatarArt(): AvatarArt | null {
  const [art, setArt] = useState<AvatarArt | null>(null);
  useEffect(() => {
    let cancelled = false;
    const game = clientGames.find((entry) => entry.loadAvatarArt !== undefined);
    game?.loadAvatarArt?.().then(
      (loaded) => {
        if (!cancelled) setArt(loaded);
      },
      () => undefined,
    );
    return () => {
      cancelled = true;
    };
  }, []);
  return art;
}
